function getUrlWithoutProtocol(url:any):string {
    let cleanedUrl = url.toLowerCase();

    cleanedUrl = cleanedUrl.replace("https://", "");
    cleanedUrl = cleanedUrl.replace("http://", "");

    return cleanedUrl;
}

export default getUrlWithoutProtocol;